import React from 'react'
import { Button } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'
import { withRouter, Link } from 'react-router-dom'

const styles = theme => ({
  authButtons: {
    marginLeft: theme.spacing.unit
  },
  navLink: {
    textDecoration: 'none',
    color: 'black'
  }
})

const AuthorizedControls = ({ classes, email, onLogOutClick, location }) => {
  const { t } = useTranslation()

  const renderButtons = () => {
    const { pathname } = location
    switch (pathname) {
      case '/':
        return (
          <>
            {/* Personal cabinet button */}
            <Button className={classes.authButtons} variant='contained'>
              <Link to='/cabinet' className={classes.navLink}>
                {t('TopBar:cabinet')}
              </Link>
            </Button>

            {/* Change password button */}
            <Button className={classes.authButtons} variant='contained'>
              {t('TopBar:change password')}
            </Button>
          </>
        )
      case '/cabinet':
        return (
          <>
            {/* Main page button */}
            <Button className={classes.authButtons} variant='contained'>
              <Link to='/' className={classes.navLink}>
                {t('TopBar:main page')}
              </Link>
            </Button>
          </>
        )
      default:
        return (
          <>
            {/* Personal cabinet button */}
            <Button className={classes.authButtons} variant='contained'>
              <Link to='/cabinet' className={classes.navLink}>
                {t('TopBar:cabinet')}
              </Link>
            </Button>
            {/* Main page button */}
            <Button className={classes.authButtons} variant='contained'>
              <Link to='/' className={classes.navLink}>
                {t('TopBar:main page')}
              </Link>
            </Button>
          </>
        )
    }
  }

  return (
    <>
      <h3>{email}</h3>

      {renderButtons()}

      {/* Log out button */}
      <Button className={classes.authButtons}
        variant='contained'
        onClick={onLogOutClick}
      >
        <Link to='/' className={classes.navLink}>
          {t('TopBar:log out')}
        </Link>
      </Button>
    </>
  )
}

export default withRouter(withStyles(styles)(AuthorizedControls))
